export default {
  language: null,
  languages: [],
  idiom: null
}
